import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useLanguage } from "@/contexts/LanguageContext";
import { Shield, FileText, Scale } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const Terms = () => {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen flex flex-col bg-background">
            <Navbar />
            <main className="flex-1 pt-24 pb-16">
                <div className="container mx-auto px-4 max-w-4xl">
                    <div className="text-center mb-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
                        <div className="inline-flex items-center justify-center p-3 bg-primary/10 rounded-2xl mb-4 text-primary">
                            <Scale className="h-8 w-8" />
                        </div>
                        <h1 className="text-4xl font-bold mb-4">{t("ข้อกำหนดการใช้บริการ", "Terms of Service")}</h1>
                        <p className="text-muted-foreground">{t("ปรับปรุงล่าสุดเมื่อ 1 มกราคม 2567", "Last updated: January 1, 2024")}</p>
                    </div>

                    <Card variant="glass" className="border-primary/10 shadow-xl animate-in fade-in duration-700 delay-200">
                        <CardContent className="p-8 md:p-12 prose prose-slate dark:prose-invert max-w-none">
                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                                    <FileText className="h-6 w-6 text-primary" />
                                    1. {t("การยอมรับข้อกำหนด", "Acceptance of Terms")}
                                </h2>
                                <p>
                                    {t(
                                        "โดยการใช้งานบริการนี้ คุณตกลงที่จะผูกพันตามข้อกำหนดและเงื่อนไขเหล่านี้ หากคุณไม่เห็นด้วยกับข้อกำหนดใดๆ คุณต้องหยุดการใช้งานบริการทันที",
                                        "By using this service, you agree to be bound by these terms and conditions. If you do not agree with any of these terms, you must stop using the service immediately."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                                    <Shield className="h-6 w-6 text-primary" />
                                    2. {t("การใช้งานที่ได้รับอนุญาต", "Permitted Use")}
                                </h2>
                                <p>
                                    {t(
                                        "คุณตกลงที่จะใช้บริการนี้เพื่อวัตถุประสงค์ที่ชอบด้วยกฎหมายเท่านั้น และจะไม่ใช้งานในทางที่ทำให้เกิดความเสียหาย หรือขัดต่อกฎหมายและระเบียบข้อบังคับใดๆ",
                                        "You agree to use this service for lawful purposes only and will not use it in any way that causes damage or violates any laws or regulations."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">3. {t("บัญชีผู้ใช้งาน", "User Account")}</h2>
                                <p>
                                    {t(
                                        "คุณมีหน้าที่รับผิดชอบในการรักษาความลับของชื่อผู้ใช้งานและรหัสผ่านของคุณ และกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้บัญชีของคุณ",
                                        "You are responsible for maintaining the confidentiality of your username and password and for all activities that occur under your account."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">4. {t("การชำระเงินและเครดิต", "Payment and Credits")}</h2>
                                <p>
                                    {t(
                                        "เครดิตที่ซื้อไปแล้วไม่สามารถแลกเปลี่ยนเป็นเงินสดหรือโอนไปยังบัญชีอื่นได้ เว้นแต่จะระบุไว้เป็นอย่างอื่นในนโยบายการคืนเงินของเรา",
                                        "Purchased credits cannot be exchanged for cash or transferred to another account, unless otherwise specified in our refund policy."
                                    )}
                                </p>
                            </section>

                            <section className="mb-8">
                                <h2 className="text-2xl font-bold mb-4">5. {t("การสิ้นสุดการให้บริการ", "Termination")}</h2>
                                <p>
                                    {t(
                                        "เราขอสงวนสิทธิ์ในการระงับหรือยกเลิกการเข้าถึงบริการของคุณเมื่อใดก็ได้ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า หากคุณละเมิดข้อกำหนดเหล่านี้",
                                        "We reserve the right to suspend or terminate your access to the service at any time without prior notice if you violate these terms."
                                    )}
                                </p>
                            </section>

                            <div className="mt-12 pt-8 border-t border-border/50 text-sm text-muted-foreground italic">
                                {t(
                                    "* หากมีคำถามเพิ่มเติมเกี่ยวกับข้อกำหนดการใช้งาน โปรดติดต่อฝ่ายสนับสนุนของเรา",
                                    "* If you have further questions regarding the terms of use, please contact our support team."
                                )}
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Terms;
